module.exports = __webpack_public_path__ + "img/Guyana.6368eec7.svg";